/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */
import React from "react";
import {Button} from 'react-bootstrap';
import CompanyInfo from "./CompanyInfo";
import SettingsNav from "./SettingsNav";
import SettingsPanelForm from "./SettingsPanelForm";

const SettingsPanel = () => {

    return (
        <div id="od_settings_panel" className="offcanvas offcanvas-right offcanvas">
            <div className="offcanvas-header d-flex align-items-center justify-content-between p-5">
                <h6 className="font-weight-bold m-0">Customers</h6>

                <Button variant="primary"
                        className="btn-icon btn-light btn-hover-primary btn-xs"
                        id="od_settings_panel_close">
                    <i className="ki ki-close icon-xs text-muted"/>
                </Button>
            </div>

            <CompanyInfo/>

            <div className="offcanvas-content px-10 pt-6">
                <SettingsPanelForm/>

                <div className="separator separator-dashed mt-8 mb-5"></div>

                <SettingsNav/>
            </div>
        </div>
    );
}

export default SettingsPanel;
